import React, { useMemo, isValidElement } from 'react';
import { useBreakpointValue, Flex, Box } from '@chakra-ui/react';
import { Typography } from '../Typography/component.js';
function renderItem(value, isHeader) {
  return useMemo(function () {
    if ( /*#__PURE__*/isValidElement(value)) {
      return value;
    }
    return /*#__PURE__*/React.createElement(Typography, {
      variant: isHeader ? 'h6' : undefined,
      color: isHeader ? 'gray.800' : 'gray.600',
      fontWeight: isHeader ? 'bold' : undefined,
      textStyle: isHeader ? undefined : 'p3'
    }, value);
  }, [value, isHeader]);
}
var DefinitionList = function DefinitionList(_ref) {
  var items = _ref.items,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'row' : _ref$variant;
  var isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  var direction = useMemo(function () {
    return variant === 'row' && !isMobile ? 'row' : 'column';
  }, [variant, isMobile]);
  return /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    as: "dl",
    alignItems: "stretch",
    flexWrap: "nowrap",
    "data-testid": "core-definition-list"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Flex, {
      direction: direction,
      gap: 2,
      py: 4,
      alignItems: "flex-start",
      key: index,
      borderBottom: "1px solid",
      borderBottomColor: "gray.200"
    }, /*#__PURE__*/React.createElement(Box, {
      flex: "0 1 25%",
      as: "dt"
    }, renderItem(item.header, true)), /*#__PURE__*/React.createElement(Box, {
      as: "dd",
      flex: "1 1 51%"
    }, renderItem(item.description, false)));
  }));
};
DefinitionList.displayName = "DefinitionList";
export { DefinitionList };